import { EventEmitter, Injectable } from '@angular/core';
import { ETransfersServiceCode } from '@common/models';
import { CommonService } from 'src/app/common.service';
import { IContextualMenu } from 'src/app/common/models/contextual-menu.model';
import { HttpRequest, HttpProviderService, IHttpSuccessPayload, CriteriaQuery, ILookupResponse } from '@fpx/core';
import { Paymentservices } from '../paymentservices-service/paymentservices.model';
import { environment } from 'src/environments/environment';
import { AccountsService } from 'src/app/services/accounts/accounts.service';
import moment from 'moment';
import { API_DATE_FORMAT } from '@common/constants';
import { Observable, catchError, map, of } from 'rxjs';
import { UserService } from 'src/app/user.service';
import { Autodeposit } from '../autodeposit-service/autodeposit.model';

@Injectable({
  providedIn: 'root'
})
export class TransfersMainService {

  autoDepositData:Autodeposit;
  transfersServiceData:Paymentservices[];
  newTranAccountNumEmit: EventEmitter<any>;showFavourite: boolean;
  transfersFilterData: any;
  nextPayIDNav : any;

  refreshDesktopFavTransfer: EventEmitter<any>;
  favPayments;
  menuItem: IContextualMenu[] = [
    {
      id: "T001",
      icon: "new-payment",
      name: "CONTEXTULAMENU.newPayment",
      title: "CONTEXTULAMENU.newPaymentTitle",
      path: ["process-shell", "transfers", "new-transfers"],
      desktopPath: ["home","transfers","process-shell", "transfers", "new-transfers"],
      serviceCode: ETransfersServiceCode.TRANSFER_NEW_TRANSFERS,
      processCode: ETransfersServiceCode.TRANSFER_NEW_TRANSFERS,
    },
    {
      id: "T002",
      icon: "add-payee",
      name: "CONTEXTULAMENU.addBeneficiary",
      title: "CONTEXTULAMENU.addBeneficiaryTitle",
      path: ["process-shell", "transfers", "add-bene-home-form"],
      desktopPath: ["home","transfers","process-shell", "transfers", "add-bene-home-form"],
      serviceCode: ETransfersServiceCode.TRANSFER_ADD_BENIFICIARY,
      processCode: ETransfersServiceCode.TRANSFER_ADD_BENIFICIARY,
    },
    {
      id: "T003",
      icon: "manage-payee",
      name: "CONTEXTULAMENU.managebeneficiary",
      title: "CONTEXTULAMENU.beneficiaryTitle",
      path: ["process-shell", "transfers", "manage-bene-form"],
      desktopPath: ["home","transfers","process-shell", "transfers", "manage-bene-form"],
      serviceCode: ETransfersServiceCode.TRANSFER_MANAGE_BENIFICIARY,
      processCode: ETransfersServiceCode.TRANSFER_MANAGE_BENIFICIARY,
    },
    // {
    //   id: "T004",
    //   icon: "own-account-payment",
    //   name: "CONTEXTULAMENU.ownAccountBank",
    //   title: "CONTEXTULAMENU.ownAccountBank",
    //   path: ["process-shell", "transfers", "own-account-transfers"],
    //   serviceCode: ETransfersServiceCode.TRANSFER_OWNACCOUNT_TRANSFERS,
    //   processCode: ETransfersServiceCode.TRANSFER_OWNACCOUNT_TRANSFERS,
    // },
    // {
    //   id: "T005",
    //   icon: "with-in-bank",
    //   name: "CONTEXTULAMENU.withInBank",
    //   title: "CONTEXTULAMENU.withInBankTitle",
    //   path: ["process-shell", "transfers", "with-in-bank-benificiary"],
    //   serviceCode: ETransfersServiceCode.TRANSFER_WITHIN_BANK_TRANSFERS,
    //   processCode: ETransfersServiceCode.TRANSFER_WITHIN_BANK_TRANSFERS,
    // },
    // {
    //   id: "T006",
    //   icon: "domestic-transfer",
    //   name: "CONTEXTULAMENU.domesticTransfer",
    //   title: "CONTEXTULAMENU.domesticTransferTitle",
    //   path: ["process-shell", "transfers", "domestic-transfers"],
    //   serviceCode: ETransfersServiceCode.TRANSFER_DOMESTIC_TRANSFERS,
    //   processCode: ETransfersServiceCode.TRANSFER_DOMESTIC_TRANSFERS,
    // },
    // {
    //   id: "T007",
    //   icon: "international-transfer",
    //   name: "CONTEXTULAMENU.internationalTransfer",
    //   title: "CONTEXTULAMENU.internationalTransferTitle",
    //   path: ["process-shell", "transfers", "transfers-add-bene-swift-form"],
    //   serviceCode: ETransfersServiceCode.TRANSFER_INTERNATIONAL_TRANSFERS,
    //   processCode: ETransfersServiceCode.TRANSFER_INTERNATIONAL_TRANSFERS,
    // }

  ];
  contextualMenuList: IContextualMenu[]=[];


  // billerInfo: Map<string, any> = new Map<string, any>;

  constructor(public _userService:UserService,public accountsService: AccountsService,public commonService: CommonService,private _httpProvider:HttpProviderService) {
  }

  getMenuList(): IContextualMenu[] {
    return this.contextualMenuList;
  }


  setMenuList(){
    if(this.commonService.isMobile()) {
    //checkpayid starts
    this.getPayIdCheck().subscribe((res: any) => {
      console.log("getRegisterPayId",res);
      this.commonService.mobileNumber=res.MOBNO;
      this.commonService.whatsappNumber=res.WHATSAPPNO;
      this.commonService.email=res.EMAILADD;
      this.commonService.mobilePayID=res.MOBILE_PAYID;
      this.commonService.emailPayID=res.EMAIL_PAYID;
      this.commonService.whatsAppyID=res.WHATSAPP_PAYID;
      this.commonService.primaryAccVal=res.PRIMARY_ACCOUNT_VAL;
      this.commonService.inventoryNumber=res.INVNO;
    //  var nextNav;
      if(this.commonService.mobilePayID== null || this.commonService.mobilePayID== "" || this.commonService.mobilePayID==undefined){
        this.nextPayIDNav =  "payid-form";
      }
      else{
        this.nextPayIDNav = "manage-payid-form";
      }  
      let contextualMenuList = [];
      // let transfersServiceData = this.getSortedtransfersServiceDataArray(this.transfersServiceData,"ordSl")
      this.transfersServiceData.forEach(element=>{
        if(element.serviceCode != 'PAYTOPAYID') {
        let nav = element?.serviceCode=='TRANOAT'?element?.serviceCode+'-transfers':element?.serviceCode+'-transfers'
        if(element.enabled=='1'){
          let name = element?.name?.split(' ');
          let append = "<em>"+name?.[name.length-1]+"</em>"
          name.pop();
          name.push(append);
          contextualMenuList.push(
              {
                id: element?.serviceCode,
                icon: element?.icon,
                name: name?.toString()?.replaceAll(',',' '),
                title: element?.name,
                path: ["process-shell", "transfers",nav],
                desktopPath: ["home","transfers","process-shell", "transfers", nav],
                serviceCode: element?.serviceCode,
                processCode: "COREPROCESS"
              }
            )
            
        }
      }
      
      })
      contextualMenuList.push(
        {
          id: 'manage-payid-form',
          icon: 'add-payee',
          name: 'Create/Manage PayId',
          title: 'Create/Manage PayId',
          path: ["process-shell", "transfers",this.nextPayIDNav],
          serviceCode: "manage-payid-form",
          processCode: "COREPROCESS"
        }
      )
      contextualMenuList.push(
        {
          id: 'PAYID-transfers',
          icon: 'with-in-bank',
          name: 'Pay to payId',
          title: 'Pay to payId',
          path: ["process-shell", "transfers","PAYID-transfers"],
          desktopPath: ["home","transfers","process-shell", "transfers", "PAYID-transfers"],
          serviceCode: "PAYID-transfers",
          processCode: "COREPROCESS"
        }
      )
    
      this.contextualMenuList = [...this.menuItem,...contextualMenuList]
    }, err => {
      console.log("getRegisterPayIderror");
    })  
  }
    //checkpayid ends
  else {
    let contextualMenuList = [];
    // let transfersServiceData = this.getSortedtransfersServiceDataArray(this.transfersServiceData,"ordSl")
    this.transfersServiceData.forEach(element=>{
      if(element.serviceCode != 'PAYTOPAYID') {
      let nav = element?.serviceCode=='TRANOAT'?element?.serviceCode+'-transfers':element?.serviceCode+'-transfers'
      if(element.enabled=='1'){
        let name = element?.name?.split(' ');
        let append = "<em>"+name?.[name.length-1]+"</em>"
        name.pop();
        name.push(append);
        contextualMenuList.push(
            {
              id: element?.serviceCode,
              icon: element?.icon,
              name: name?.toString()?.replaceAll(',',' '),
              title: element?.name,
              path: ["process-shell", "transfers",nav],
              desktopPath: ["home","transfers","process-shell", "transfers", nav],
              serviceCode: element?.serviceCode,
              processCode: "COREPROCESS"
            }
          )
      }
    }
    })
    this.contextualMenuList = [...this.menuItem,...contextualMenuList]
  }
  }

getPayIdCheck(): Observable<any>{
    const httpRequest = new HttpRequest();
    httpRequest.setResource('/checkpayid');
    httpRequest.setServerContext(environment.transfersPublisher);
    httpRequest.setMethod('GET');
       return this._httpProvider.invokeRestApi(httpRequest).pipe(
      map((res: IHttpSuccessPayload<ILookupResponse>) => {
        return res.body;
      })
     );   
  }


  setAutoDeposit() {
    const httpRequest = new HttpRequest();
    httpRequest.setServerContext(environment.transfersPublisher);
    httpRequest.setResource('/autodeposit/{customerCode}');
     httpRequest.addPathParameter('customerCode', this._userService.customerCode);
    httpRequest.setMethod('GET');
    return this._httpProvider
      .invokeRestApi(httpRequest)
      .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.autodeposit ?? null), map((res:any) => {
        return res ? {...res, } : null
      }),catchError((err:any) => {
            return of(null)
      })).subscribe(item=>{
        this.autoDepositData = item
      });
}


  getBeneficiaryTitle(serviceCode) {
    switch (serviceCode) {
      case 'TRANOAT': return 'Own Account Transfer'
      case 'TRANINTBT': return 'Within Bank Transfer'
      case 'TRANDOMESTIC': return 'Domestic Transfer'
      case 'BENEINTBT': return 'Within Bank Beneficiary'
      case 'BENESWIFT': return 'International Beneficiary'
      case 'BENEIFSC': return ' Bank to Bank Beneficiary'
      case 'BENEDOMESTIC': return ' Domestic Beneficiary'
      case 'INTRAC': return 'INTERAC Beneficiary'
      case 'INTRACSEND': return 'INTERAC Beneficiary'
      case 'INTRACREQUEST': return 'INTERAC Beneficiary'
      case 'TRANINTERNATIONAL': return 'International Transfer'
      case 'BENEINTERNATIONAL': return 'Add Beneficiary'
    }
  }


  async loadTransfersService(){
    this.autoDepositData = undefined;
    const httpRequest = new HttpRequest();
    httpRequest.setServerContext(environment.transfersPublisher);
    httpRequest.setResource('/paymentservices');
    const httpCriteria = new CriteriaQuery();

    httpCriteria.addSortCriteria('ordSl','asc','Numeric');
    httpRequest.setCriteriaQuery(httpCriteria);

    httpRequest.setMethod('GET');
    // httpRequest.setServerContext(environment.accountsPublisher);
    await this._httpProvider.invokeRestApi(httpRequest).subscribe({
      next: (res) => {
        this.transfersServiceData = res.body.paymentservices
      }
    });
  }


  compareWithExistForm(currentFormData, previousFormData) {

    let deepCompare = (arg1, arg2) => {
      if (Object.prototype.toString.call(arg1) === Object.prototype.toString.call(arg2)) {
        if (Object.prototype.toString.call(arg1) === '[object Object]' || Object.prototype.toString.call(arg1) === '[object Array]') {
          if (Object.keys(arg1).length !== Object.keys(arg2).length) {
            return false;
          }
          return (Object.keys(arg1).every(function (key) {
            return deepCompare(arg1[key], arg2[key]);
          }));
        }
        return (arg1 === arg2);
      }
      return false;
    }

    let trimObj = (obj) => {
      if (!Array.isArray(obj) && typeof obj != 'object') return obj;
        return Object.keys(obj).reduce(function(acc, key) {
          acc[key?.trim()?.toUpperCase()] = typeof obj[key] == 'string'? obj[key].trim()?.toUpperCase() : trimObj(obj[key]);
          return acc;
      }, Array.isArray(obj)? []:{});
    }

    return deepCompare(trimObj(previousFormData), trimObj(currentFormData))

  }

  getBeneInitial(beneName: string) {
    if (beneName && beneName != '') {
      let initial: string = beneName.charAt(0);
      if (beneName.split(' ').length > 1) {
        initial = initial + beneName.split(' ')[1].charAt(0);
      }
      return initial;
    }
    return
  }


  getPaymentDescriptionByType(paymentSystem) {
    switch (paymentSystem) {
      case 'INTBT': return 'Within bank'
      case 'SWIFT': return 'International bank'
      case 'OAT': return 'Own account'
      case 'ACH': return ' Domestic bank'
      case 'INTRACSEND': return 'Intrac bank'
      case 'INTRACREQUEST': return 'Intrac bank'
      case 'PAYMENTACH': return 'paymentach'
      case 'PAYMENTSWIFT': return 'paymentswift'
    }
  }
  getPaymentApiFlag(systemCode){
    switch (systemCode) {
      case 'TRANINTBT': return 'paymentinternal'
      case 'TRANSWIFT': return 'paymentswift'
      case 'TRANIFSC': return 'paymentifsc'
      case 'TRANINTRACSEND': return 'paymentintracsend'
      case 'TRANINTRACREQUEST': return 'paymentintracrequest'
      case 'ACH': return ' Domestic bank'
      case 'PAYMENTACH': return 'paymentach'
      case 'PAYMENTSWIFT': return 'paymentswift'
    }
  }

  getAccountList(){
    return this.accountsService.getList();
  }


  getAccountListById(accNum){
    return this.accountsService.getAccountDetailsData(accNum);
  }


  apiAmountformat(tranAmount: any) {
    if(!tranAmount || tranAmount!=null || tranAmount!='' ){
      return  parseFloat(tranAmount)
    }else{
      return 0.00
    }
  }

  getminAndMaxDate(duration?,yearOrMonth?){
    if(yearOrMonth){
      return moment(new Date()).add(duration,yearOrMonth).format(API_DATE_FORMAT);
    }else{
      return moment(new Date()).format(API_DATE_FORMAT);
    }

  }


  endDateCalculation(frequency, noOfInstallment, startDate){
    if (frequency && noOfInstallment && startDate && noOfInstallment>0) {
      let startDateTemp;
      if (frequency == '1') {
        startDateTemp = moment(startDate).add(Number(noOfInstallment) - 1, "d").format('YYYY-MM-DD')
      } else if (frequency == '2') {
        startDateTemp = moment(startDate).add(Number(noOfInstallment) - 1, 'M').format('YYYY-MM-DD')
      }
      else if (frequency == '3') {
        startDateTemp = moment(startDate).add(Number(noOfInstallment) - 1, "y").format('YYYY-MM-DD')
      }else if (frequency == '4') {
        startDateTemp = moment(startDate).add(Number(noOfInstallment) - 1, "w").format('YYYY-MM-DD')
        startDateTemp = moment(startDateTemp).add(Number(noOfInstallment) - 1, "w").format('YYYY-MM-DD')
      }else if (frequency == '5') {
        startDateTemp = moment(startDate).add(Number(noOfInstallment) - 1, "w").format('YYYY-MM-DD')
      }else if (frequency == '6') {
        startDateTemp = moment(startDate).add(Number(noOfInstallment) - 1, "Q").format('YYYY-MM-DD')
      }
      return startDateTemp;
    } else {
      return undefined;
    }

  }


  getTranServiceDataBySystemCode(systemCode: string) {
    return this.transfersServiceData?.find(x=>x.systemCode === systemCode)
  }


  insufficiantBalanceCheck(debitAccountNumber, amount) {
    // if (debitAccountNumber && amount) {
    //   let actualBalance = this._accountService.getAccountSummaryData(debitAccountNumber)?.actualBalance;
    //   if (parseFloat(amount) <= actualBalance) {
    //     return true;
    //   }
    //   else {
    //     return false;
    //   }
    // }
  }


  serviceLimits(formGroupData,serviceCode):Observable<any> {
    if(formGroupData.paymentDate){
    let paymentDate = formGroupData.paymentDate.split(' ');
    let accountData = this.getAccountListById(formGroupData?.debitAccount);
    const httpRequest = new HttpRequest();
    httpRequest.setMethod('POST');
    httpRequest.setResource('/core/validation');
    let payload:any;
    if(serviceCode!='TRANSINTER'){
     payload = {
      "tranAmount" : formGroupData.paymentAmount,
      "tranCurrency" : accountData.accountCurrency,
      "tranDate" : paymentDate?.[0],
      "serviceCode" : serviceCode
    }
  }
  else{
    //for International fund transfer
         payload = {
      "tranAmount" : formGroupData.debitAmount,
      "tranCurrency" : accountData.accountCurrency,
      "tranDate" : paymentDate?.[0],
      "serviceCode" : serviceCode
    }
  }
    httpRequest.setBody(payload);
    return this._httpProvider.invokeRestApi(httpRequest)
    }
}

getPendingDailyLimits(serviceCode):Observable<any> {
  const httpRequest = new HttpRequest();
  httpRequest.setMethod('GET');
  httpRequest.setResource('/v1/transfersdailylimitdtls');
  httpRequest.addQueryParameter('transfertype',serviceCode);
  httpRequest.setServerContext(environment.transfersPublisher);
  return this._httpProvider.invokeRestApi(httpRequest)
}
  // basicAmountValidation(amount, debitAccount) {
  //   let fromAccData: any = this.getAccountListById(debitAccount);
  //   console.log(fromAccData)
  //   if (Number(amount) == 0.00) {
  //     return 'INVALIDAMOUNT';
  //   }

  // }
  basicAmountValidation(amount, debitAccount) {
    let fromAccData: any = this.getAccountListById(debitAccount);
    console.log(fromAccData)
    if (amount && parseFloat(amount) == 0.00) {
      return 'INVALIDAMOUNT';
    }
    if ((amount && fromAccData.availableBalance && parseFloat(amount) > parseFloat(fromAccData.availableBalance)) || fromAccData.availableBalance == 0) {
      return 'AVAILABLEBALANCE';
    }

  }


}
